import { render, staticRenderFns } from "./accesslogManage.vue?vue&type=template&id=a4f2687a"
import script from "./accesslogManage.vue?vue&type=script&lang=js"
export * from "./accesslogManage.vue?vue&type=script&lang=js"
import style0 from "./accesslogManage.vue?vue&type=style&index=0&id=a4f2687a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports